import React from 'react';
import { Card, CardContent, Typography, Switch, FormControlLabel, Box, Grid } from '@mui/material';

export default function RelayControl({ label, state, onToggle, icon, color = 'default' }) {
    const isOn = !!state;
    const getColor = () => {
        if (color === 'primary') return '#4CAF50';
        if (color === 'secondary') return '#2196F3';
        return state ? '#FF6B6B' : '#666';
    };

    return (
        <Grid item xs={12} sm={6} md={4} lg={3}>
            <Card sx={{
                border: isOn ? `2px solid ${getColor()}` : '2px solid #333',
                transition: 'all 0.3s ease'
            }}>
                <CardContent>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Box display="flex" alignItems="center">
                            {icon && <Box sx={{ mr: 1, color: getColor() }}>{icon}</Box>}
                            <Typography variant="body1">{label}</Typography>
                        </Box>
                        <FormControlLabel
                            control={<Switch checked={isOn} onChange={(e) => onToggle(e.target.checked)} color={color} />}
                            label={isOn ? 'Ligado' : 'Desligado'}
                            labelPlacement="end"
                        />
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
}
